import React from 'react';
import { Grid, Typography } from '@mui/material';
import moment from 'moment';
import { User, UserStatus } from '../../../shared/types/generated';
import currencyFormatter from 'currency-formatter';
import { ActionMenu } from '../../../shared/components/ActionMenu';
import { deleteUserDialogStoreAction, userChangeStatusDialogStoreAction } from '../user-actions';

type UserItemProps = {
  item?: User;
};

export const UserItem: React.FC<UserItemProps> = ({ item }) => {
  const role = item?.roles_on_users?.length ? item?.roles_on_users[0]?.role : undefined;
  const balance = currencyFormatter.format(item?.meta_api_cloud_metrics?.balance as number, {
    code: item?.meta_api_cloud_account?.currency as string || 'USD',
  });


  return (
    <Grid container py={'5px'} px={'15px'} borderBottom={'1px solid #F0F0F0'}>
      <Grid item xs={2} textAlign='center'>{`${item?.first_name || ''} ${
        item?.meta_api_cloud_account?.name || ''
      }`}</Grid>
      <Grid item xs={2} textAlign='center'>
        {item?.email}
      </Grid>
      <Grid item xs={1} textAlign='center'>
        {role?.name}
      </Grid>
      <Grid item xs={1} textAlign='center'>
        {balance}
      </Grid>
      <Grid item xs={1} textAlign='center'>
        {item?.meta_api_cloud_metrics?.profit || 0}
      </Grid>
      <Grid item xs={1} textAlign='center'>
        {moment(item?.created_at).format('YYYY-MM-DD')}
      </Grid>
      <Grid item xs={2}>
        <Typography>{item?.meta_api_cloud_account?.suspended_at ? `Yes (${moment(item?.meta_api_cloud_account?.suspended_at).tz('America/New_York').format('LLL')})` : 'No'}</Typography>
      </Grid>
      <Grid item xs={1} textAlign='center'>
        {item?.status}
      </Grid>
      <Grid item xs={1} textAlign='center'>
        <ActionMenu actions={[
          {
            actionName: `${item?.status === UserStatus.Active ? 'Deactivate' : 'Activate'}`,
            onClick: (user) => {
              userChangeStatusDialogStoreAction({ open: true, user });
            },
          },
          {
            actionName: 'Delete',
            onClick: (user) => {
              deleteUserDialogStoreAction({ open: true, user });
            },
          },
        ]} item={item as User} />
      </Grid>
    </Grid>
  );
};
